import React from "react";
import ApiService from "../../../services/ApiService";
import AddCircleOutlineOutlinedIcon from "@mui/icons-material/AddCircleOutlineOutlined";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AccordionOperations from "../../../components/Operations/AccordionOperations";
import OperationModalRegisterOrUpdate from "../../../components/Operations/OperationModalRegisterOrUpdate";
import { Spinner, Dropdown, Alert, Card, Modal, Button } from "react-bootstrap";
import Select from "react-select";
import { store } from "../../../reducer/Store";
import TableDynamic from "../../../components/TableDynamic";
import { ToastContainer, toast } from "react-toastify";

const DetailsPlan = ({ detailsPlan, showApplyPlan, setShowApplyPlan }) => {
  const { dispatch, state } = React.useContext(store);
  const [showAddOperation, setShowAddOperation] = React.useState(false);
  const [showUpdateOperation, setShowUpdateOperation] = React.useState(false);
  const [commentOperation, setCommentOperation] = React.useState("");
  const [descriptionOtherOffer, setDescriptionOtherOffer] = React.useState("");
  const [selectOperation, setSelectOperation] = React.useState("");
  const [selectOffre, setSelectOffre] = React.useState("");
  const [selectPrestataire, setSelectPrestataire] = React.useState("");
  const [monthOne, setMonthOne] = React.useState("");
  const [monthTwo, setMonthTwo] = React.useState("");
  const [monthThree, setMonthThree] = React.useState("");
  const [operationId, setOperationId] = React.useState("");
  const [isCheckedComTool, setCheckedComTool] = React.useState();
  const [isCheckedMerchandising, setCheckedMerchandising] = React.useState();
  const [operationCommunicationToolsData, setOperationCommunicationToolsData] =
    React.useState([]);
  const [operationMerchandisingData, setOperationMerchandisingData] =
    React.useState([]);
  const [errorMessageMonths, setErrorMessageMonths] = React.useState("");
  const columnsName = ["", "Liste clients"];
  const columns = ["id", "name"];
  const [noResultMessage, setNoResultMessage] = React.useState(false);
  const [checkedCustomersListIds, setCheckedCustomersListIds] = React.useState(
    []
  );
  const allMonth = state.allMonth;
  const [filterMonth, setFilterMonth] = React.useState(allMonth[0]);

  const handleShowAdd = () => setShowAddOperation(true);

  /**
   * Cette fonction est appelée lorsqu'on souhaite afficher la fenêtre modale de modification d'une opération.
   * Elle initialise les différents états pour les champs de la fenêtre modale avec les valeurs de l'opération passée en paramètre.
   * @param {Object} operation - L'opération à modifier.
   */
  const handleShowUpdate = (operation) => {
    setSelectPrestataire(operation.provider_id);
    setSelectOperation(operation.operation_type_id.toString());
    setSelectOffre(
      state.operationsType
        .filter((elt) => elt.id === operation.operation_type_id)[0]
        .operation_descriptions.filter(
          (opeDesc) => opeDesc.name === operation.description
        )[0]
        ? state.operationsType
            .filter((elt) => elt.id === operation.operation_type_id)[0]
            .operation_descriptions.filter(
              (opeDesc) => opeDesc.name === operation.description
            )[0].id
        : "autre"
    );
    setCommentOperation(operation.comment);
    setDescriptionOtherOffer(
      state.operationsType
        .filter((elt) => elt.id === operation.operation_type_id)[0]
        .operation_descriptions.filter(
          (opeDesc) => opeDesc.name === operation.description
        )[0]
        ? ""
        : operation.description
    );
    setMonthOne(operation.month_1.toString());
    setMonthTwo(operation.month_2 ? operation.month_2.toString() : "");
    setMonthThree(operation.month_3 ? operation.month_3.toString() : "");
    handleUpdateComTool(operation.operation_com_tool);
    handleUpdateMerchandising(operation.operation_plv_value);
    setOperationId(operation.id);
    setShowUpdateOperation(true);
  };

  const handleClose = () => {
    setSelectPrestataire("");
    setShowApplyPlan(false);
    setCheckedCustomersListIds([]);
    setErrorMessageMonths("");
    setOperationId("");
    setSelectOperation("");
    setSelectOffre("");
    setCommentOperation("");
    setDescriptionOtherOffer("");
    setMonthOne("");
    setMonthTwo("");
    setMonthThree("");
    setCheckedComTool(isCheckedComTool.fill(false));
    setCheckedMerchandising(isCheckedMerchandising.fill(false));
    setOperationMerchandisingData([]);
    setOperationCommunicationToolsData([]);
    setShowUpdateOperation(false);
    setShowAddOperation(false);
  };

  /**
   * Cette fonction met à jour les données de l'outil de communication d'une opération donnée en fonction de l'état des cases à cocher correspondantes.
   * @param {Array} opeComTool - Les données de l'outil de communication de l'opération à mettre à jour.
   */
  const handleUpdateComTool = (opeComTool) => {
    var tab = isCheckedComTool.fill(false);
    opeComTool.forEach((e) =>
      state.listComTools.forEach((elt, i) =>
        elt.id === e.operation_com_tool_type_id ? (tab[i] = true) : ""
      )
    );
    var comToolsData = [];
    tab.forEach((elt, i) =>
      elt === true
        ? comToolsData.push({
            operation_com_tool_type_id: state.listComTools[i].id,
            operation_id: "",
            name: state.listComTools[i].name,
          })
        : ""
    );
    setCheckedComTool(tab);
    setOperationCommunicationToolsData(comToolsData);
  };

  /**
   * Cette fonction met à jour les données de merchandising pour un plan de détails donné, en fonction des opérations de PLV effectuées.
   * @param { Array } opePlv - Les opérations de PLV effectuées.
   */
  const handleUpdateMerchandising = (opePlv) => {
    var tab = isCheckedMerchandising.fill(false);
    opePlv.forEach((e) =>
      state.listDetailsPlanPlvs.forEach((elt, i) =>
        elt.id === e.operation_plv_id ? (tab[i] = true) : ""
      )
    );
    var plvData = [];
    tab.forEach((elt, i) =>
      elt === true
        ? plvData.push({
            plan_id: detailsPlan.id,
            operation_plv_id: state.listDetailsPlanPlvs[i].id,
            quantity_max: state.listDetailsPlanPlvs[i].quantity_max,
            quantity: opePlv.filter(
              (elt) => elt.operation_plv_id === state.listDetailsPlanPlvs[i].id
            )[0]
              ? opePlv.filter(
                  (elt) =>
                    elt.operation_plv_id === state.listDetailsPlanPlvs[i].id
                )[0].quantity
              : 1,
            operation_id: "",
          })
        : ""
    );
    setOperationMerchandisingData(plvData);
    setCheckedMerchandising(tab);
  };

  /**
   * Cette fonction gère le changement d'état d'une case à cocher pour les outils de communication d'une opération.
   * Elle met à jour la liste des outils de communication sélectionnés en fonction de l'état de chaque case à cocher.
   * @param { Number } position - La position de la case à cocher dans la liste des outils de communication.
   */
  const handleOnChangeComTool = (position) => {
    const updatedCheckedState = isCheckedComTool.map((item, index) =>
      index === position ? !item : item
    );
    var comToolsData = [];
    updatedCheckedState.forEach((elt, i) =>
      elt === true
        ? comToolsData.push({
            operation_com_tool_type_id: state.listComTools[i].id,
            operation_id: "",
            name: state.listComTools[i].name,
          })
        : ""
    );
    setOperationCommunicationToolsData(comToolsData);
    setCheckedComTool(updatedCheckedState);
  };

  /**
   * Cette fonction gère le changement de l'état de la case à cocher pour le merchandising sélectionné.
   * @param { Number } position - La position du merchandising dans la liste des merchandisings disponibles.
   */
  const handleOnChangeMerchandising = (position) => {
    const updatedCheckedState = isCheckedMerchandising.map((item, index) =>
      index === position ? !item : item
    );
    var plvData = [];
    updatedCheckedState.forEach((elt, i) =>
      elt === true
        ? plvData.push({
            plan_id: detailsPlan.id,
            operation_plv_id: state.listDetailsPlanPlvs[i].id,
            quantity_max: state.listDetailsPlanPlvs[i].quantity_max,
            quantity: operationMerchandisingData.filter(
              (elt) => elt.operation_plv_id === state.listDetailsPlanPlvs[i].id
            )[0]
              ? operationMerchandisingData.filter(
                  (elt) =>
                    elt.operation_plv_id === state.listDetailsPlanPlvs[i].id
                )[0].quantity
              : 1,
            operation_id: "",
          })
        : ""
    );
    setOperationMerchandisingData(plvData);
    setCheckedMerchandising(updatedCheckedState);
  };

  /**
   * Cette fonction met à jour la quantité de PLV pour une opération donnée.
   * @param { Number } id - L'identifiant de la PLV à mettre à jour.
   * @param { Number } qte - La quantité de PLV à mettre à jour.
   */
  const handleQuantityMerchandising = (id, qte) => {
    setOperationMerchandisingData((prevData) =>
      prevData.map((elt) => {
        if (elt.operation_plv_id === id) {
          return { ...elt, quantity: qte };
        } else {
          return elt;
        }
      })
    );
  };

  /**
   * Cette fonction permet de récupérer toutes les opérations associées à un plan en fonction de la marque, du plan et de l'année sélectionnée.
   * Elle utilise l'API pour faire une requête HTTP GET à l'adresse "plan-operations-by-brand-plan-year/" avec les informations de la marque, du plan et de l'année en paramètres.
   * Une fois la réponse obtenue, elle filtre les opérations par mois en utilisant la fonction "filterByMonth()" avec le mois sélectionné et les données récupérées en paramètres.
   * Si une erreur se produit lors de la requête, elle affiche le message d'erreur dans la console et désactive le loader.
   */
  const getAllOperationsByPlan = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `plan-operations-by-brand-plan-year/${detailsPlan.brand_id}/${detailsPlan.id}/${detailsPlan.year_id}`,
      "get"
    )
      .then(function (response) {
        filterByMonth(filterMonth, response.data);
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error);
        dispatch({ type: "SET_LOADER", payload: false });
      });
  };

  /**
   * Cette fonction permet d'ajouter une opération dans le plan de l'année en cours.
   * @param { Object } e - L'événement de l'ajout de l'opération.
   * @param { String } selectOperation - L'ID de l'opération sélectionnée.
   * @param { String } monthOne - Le nombre de jours pour la première période.
   * @param { String } monthTwo - Le nombre de jours pour la deuxième période.
   * @param { String } monthThree - Le nombre de jours pour la troisième période.
   * @param { String } commentOperation - Le commentaire pour l'opération.
   * @param { String } selectOffre - L'ID de l'offre sélectionnée.
   * @param { String } descriptionOtherOffer - La description de l'offre personnalisée.
   * @param { Array } operationMerchandisingData - Les données de merchandising pour l'opération.
   * @param { Array } operationCommunicationToolsData - Les données d'outils de communication pour l'opération.
   * @param { String } selectPrestataire - L'ID du prestataire sélectionné.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   */
  const addOperation = async (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        brand_id: state.operationsType.filter(
          (e) => e.id.toString() === selectOperation
        )[0].brand_id,
        year_id: state.operationsType.filter(
          (e) => e.id.toString() === selectOperation
        )[0].year_id,
        plan_id: detailsPlan.id,
        operation_type_id: selectOperation,
        month_1: monthOne,
        month_2: monthTwo,
        month_3: monthThree,
        comment: commentOperation,
        description:
          selectOffre === "autre"
            ? descriptionOtherOffer
            : state.operationsType
                .filter((elt) => elt.id.toString() === selectOperation)[0]
                .operation_descriptions.filter(
                  (elt) => elt.id.toString() === selectOffre
                )[0].name,
        operation_merchandising_data: operationMerchandisingData,
        operation_communication_tools_data: operationCommunicationToolsData,
        provider_id: selectPrestataire,
      },
      "plan-operations",
      "post"
    )
      .then(function () {
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getAllOperationsByPlan();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (
          error.response.data.message.includes(
            "quota d'opérations maximales (6) pour ce client, cette marque et cette année"
          )
        ) {
          setErrorMessageMonths(error.response.data.message);
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette méthode permet de mettre à jour une opération de plan en appelant une API. Les informations nécessaires à la mise à jour sont récupérées à partir de différents états de la page.
   * @param { Object } e - L'événement de l'ajout de l'opération.
   * @param { String } selectOperation - L'ID de l'opération sélectionnée.
   * @param { String } monthOne - Le nombre de jours pour la première période.
   * @param { String } monthTwo - Le nombre de jours pour la deuxième période.
   * @param { String } monthThree - Le nombre de jours pour la troisième période.
   * @param { String } commentOperation - Le commentaire pour l'opération.
   * @param { String } selectOffre - L'ID de l'offre sélectionnée.
   * @param { String } descriptionOtherOffer - La description de l'offre personnalisée.
   * @param { Array } operationMerchandisingData - Les données de merchandising pour l'opération.
   * @param { Array } operationCommunicationToolsData - Les données d'outils de communication pour l'opération.
   * @param { String } selectPrestataire - L'ID du prestataire sélectionné.
   * @param { Number } year_id - L'année à laquelle se rattacher.
   * @param { Number } operationId - L'id de l'operation à mettre à jour.
   */
  const updateOperation = async (e) => {
    e.preventDefault();
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        brand_id: state.operationsType.filter(
          (e) => e.id.toString() === selectOperation
        )[0].brand_id,
        year_id: state.operationsType.filter(
          (e) => e.id.toString() === selectOperation
        )[0].year_id,
        plan_id: detailsPlan.id,
        operation_type_id: selectOperation,
        month_1: monthOne,
        month_2: monthTwo,
        month_3: monthThree,
        comment: commentOperation,
        description:
          selectOffre === "autre"
            ? descriptionOtherOffer
            : state.operationsType
                .filter((elt) => elt.id.toString() === selectOperation)[0]
                .operation_descriptions.filter(
                  (elt) => parseInt(elt.id) === parseInt(selectOffre)
                )[0].name,
        operation_merchandising_data: operationMerchandisingData,
        operation_communication_tools_data: operationCommunicationToolsData,
        provider_id: selectPrestataire,
      },
      "plan-operations/" + operationId,
      "put"
    )
      .then(function () {
        handleClose();
        dispatch({ type: "SET_LOADER", payload: false });
        getAllOperationsByPlan();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (
          error.response.data.message.includes(
            "quota d'opérations maximales (6) pour ce client, cette marque et cette année"
          )
        ) {
          console.log(error.response.data.message);
          setErrorMessageMonths(error.response.data.message);
        }
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction supprime une opération spécifique en utilisant son ID.
   * @param { Number } opeId - L'ID de l'opération à supprimer.
   */
  const deleteOperation = async (opeId) => {
    if (
      window.confirm(
        "Voulez vous vraiment supprimer cette opération ? Cela est définitif."
      )
    ) {
      dispatch({ type: "SET_LOADER", payload: true });

      ApiService.request({}, "operations/" + opeId, "delete")
        .then(function () {
          dispatch({ type: "SET_LOADER", payload: false });
          getAllOperationsByPlan();
          handleClose();
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: true });
          console.log(error);
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    }
  };

  /**
   * Cette fonction prend en entrée un nombre représentant un mois et retourne le nom complet du mois correspondant en français.
   * @param {Number} month - Le nombre représentant le mois (1 pour Janvier, 2 pour Février, etc.)
   * @returns {String} - Le nom complet du mois en français.
   */
  const getNameMonth = (month) => {
    var monthName = "";
    switch (month.toString()) {
      case "1":
        monthName = "Janvier";
        break;
      case "2":
        monthName = "Février";
        break;
      case "3":
        monthName = "Mars";
        break;
      case "4":
        monthName = "Avril";
        break;
      case "5":
        monthName = "Mai";
        break;
      case "6":
        monthName = "Juin";
        break;
      case "7":
        monthName = "Juillet";
        break;
      case "8":
        monthName = "Août";
        break;
      case "9":
        monthName = "Septembre";
        break;
      case "10":
        monthName = "Octobre";
        break;
      case "11":
        monthName = "Novembre";
        break;
      case "12":
        monthName = "Décembre";
        break;
      default:
        monthName = "";
    }
    return monthName;
  };

  /**
   * Cette fonction récupère tous les types d'opérations disponibles pour la marque et l'année du plan en cours.
   */
  const getAllOperationsType = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-types-by-brands-year/${detailsPlan.brand_id}/${detailsPlan.year_id}`,
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        const operationsType = response.data;
        dispatch({ type: "SET_OPERATIONSTYPE", payload: operationsType });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        console.log(error);
        dispatch({ type: "SET_LOADER", payload: false });
      });
  };

  /**
   * Cette fonction récupère la liste des outils de communication pour une année donnée et les stocke dans le state de l'application.
   * Elle utilise l'API pour effectuer une requête GET et attend une réponse au format JSON.
   * Si la requête est réussie, elle stocke la liste des outils de communication dans le state et initialise un tableau de booléens pour indiquer si chaque outil est sélectionné ou non.
   * Si la requête échoue, elle affiche une erreur dans la console et vérifie si l'utilisateur est authentifié avant de déclencher un logout.
   * @returns { Void }
   */
  const getComTools = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-com-tool-types-by-year/${state.currentYear.value}`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTCOMTOOLS",
          payload: response.data,
        });
        setCheckedComTool(Array(response.data.length).fill(false));
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction permet de filtrer les opérations par mois sélectionné par l'utilisateur. Si la valeur du mois est égale à 0, toutes les opérations sont renvoyées.
   * @param {Object} e - Événement de changement déclenché lorsque l'utilisateur sélectionne un mois dans la liste déroulante.
   * @param {Array} opeData - Données sur les opérations à filtrer, par défaut toutes les opérations du plan détaillé sont utilisées.
   */
  const filterByMonth = (e, opeData = state.detailsPlanOperations) => {
    const data = [];
    setFilterMonth(e);
    if (e.value === 0) {
      dispatch({ type: "SET_DETAILSPLANOPERATIONS", payload: opeData });
    } else {
      opeData.forEach((elt) =>
        elt.month_1 === e.value ||
        elt.month_2 === e.value ||
        elt.month_3 === e.value
          ? data.push(elt)
          : ""
      );
      dispatch({ type: "SET_DETAILSPLANOPERATIONS", payload: data });
    }
  };

  /**
   * Cette fonction récupère les plans PLV pour un plan et une année donnés.
   * Elle met à jour la liste des détails des plans PLV dans le store Redux en utilisant la méthode "SET_LISTDETAILSPLANPLVS".
   * Elle met également à jour le state "checkedMerchandising" en initialisant chaque élément à false.
   */
  const getPlansPlv = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      `operation-plvs-by-plan-year/${detailsPlan.id}/${detailsPlan.year_id}`,
      "get"
    )
      .then(function (response) {
        dispatch({
          type: "SET_LISTDETAILSPLANPLVS",
          payload: response.data,
        });
        setCheckedMerchandising(Array(response.data.length).fill(false));
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère les plans de PLV pour un plan d'opération et une année donnés, via une requête API.
   */

  // <JC
  var state_brands_ids = state.currentBrands;
  var brands_ids = '';
  state_brands_ids.map((val) => (
    brands_ids += val.value+','
  ));
  // JC>

  const searchCustomersList = (search, page = 1, max = 25) => {
    dispatch({ type: "SET_LOADER", payload: true });
    setNoResultMessage(false);
    ApiService.request(
      {
        search,
        page,
        max,
        // <JC
        brands_ids
        // JC>
      },
      "customer-lists-search-paginated",
      "post"
    )
      .then(function (response) {
        if (response.message === "No result.") {
          setNoResultMessage(true);
        } else {
          dispatch({
            type: "SET_PLANSTRADECUSTOMERSLIST",
            payload: response.data,
          });
        }
        dispatch({ type: "SET_LOADER", payload: false });
      })
      .catch(function (error) {
        // manque un message quand c'est une error
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction recherche les clients dans la liste des plans d'action commerciale et affiche les résultats paginés.
   * @param {string} search - La chaîne de caractères à rechercher dans la liste des clients.
   * @param {number} page - Le numéro de la page à afficher. La valeur par défaut est 1.
   * @param {number} max - Le nombre maximum de résultats à afficher par page. La valeur par défaut est 25.
   */

    // <JC
    var state_brands_ids = state.currentBrands;
    var brands_ids = '';
    state_brands_ids.map((val) => (
      brands_ids += val.value+','
    ));
    // JC>

  const getPlanCustomersList = async (page = 1, max = 25) => {
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {},
      // <JC
      //`customer-lists-pagination?page=${page}&max=${max}`,
      `customer-lists-pagination?page=${page}&max=${max}&brands=${brands_ids}`,
      // JC>
      "get"
    )
      .then(function (response) {
        dispatch({ type: "SET_LOADER", payload: false });
        dispatch({
          type: "SET_PLANSTRADECUSTOMERSLIST",
          payload: response.data,
        });
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette méthode récupère le nombre total d'opérations pour un client donné et pour une année donnée, pour les marques sélectionnées par l'utilisateur.
   * Les marques sélectionnées sont stockées dans le local storage de l'application.
   * @throws {Error} - Lance une erreur si l'utilisateur n'est pas authentifié.
   */
  const getTotalNumberOfOperationByCustomer = async () => {
    var brands = [];
    JSON.parse(localStorage.getItem("currentBrands")).map((brand) =>
      brands.push(brand.value)
    );
    ApiService.request(
      {},
      `numbers-of-operations-by-brands-customer-year/${brands}/${
        state.dataSelectedClient.id
      }/${JSON.parse(localStorage.getItem("currentYear")).value}`,
      "get"
    )
      .then(function (response) {
        //console.log(response.data);
        dispatch({
          type: "SET_TOTALNUMBEROFCUSTOMEROPERATIONS",
          payload: response.data,
        });
      })
      .catch(function (error) {
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction applique un plan de trade marketing à une ou plusieurs listes de clients sélectionnées.
   * Elle appelle l'API pour appliquer le plan et met à jour les données de l'interface utilisateur en cas de succès.
   * @async
   * @function applyPlanTrade
   * @throws {Error} Si une erreur survient lors de l'appel à l'API ou si l'utilisateur n'est pas authentifié.
   */
  const applyPlanTrade = async () => {
    var id = toast.loading(
      `Le plan ${detailsPlan.name} s'applique ${
        checkedCustomersListIds.length > 1
          ? "aux listes sélectionnées"
          : "à la liste sélectionnée"
      }.`
    );
    dispatch({ type: "SET_LOADER", payload: true });
    ApiService.request(
      {
        plan_id: detailsPlan.id,
        customer_list_id: checkedCustomersListIds,
      },
      "plan-apply",
      "post"
    )
      .then(function () {
        dispatch({ type: "SET_LOADER", payload: false });
        toast.update(id, {
          render: `Le plan ${detailsPlan.name} s'est appliqué ${
            checkedCustomersListIds.length > 1
              ? "aux listes sélectionnées"
              : "à la liste sélectionnée"
          }.`,
          type: "success",
          isLoading: false,
          autoClose: 5000,
        });
        handleClose();
        getTotalNumberOfOperationByCustomer();
        getAllOperationsByPlan();
      })
      .catch(function (error) {
        dispatch({ type: "SET_LOADER", payload: false });
        toast.update(id, {
          render: `Erreur lors de l'application du plan ${detailsPlan.name}.`,
          type: "error",
          isLoading: false,
          autoClose: 5000,
        });
        console.log(error);
        if (error.response.data.message === "Unauthenticated.") {
          localStorage.clear();
          dispatch({ type: "SET_LOGOUT", payload: false });
        }
      });
  };

  /**
   * Cette fonction récupère la liste de tous les prestataires pour l'année en cours et met à jour la liste des prestataires dans le state global de l'application.
   */
  const getAllPrestataires = async () => {
    dispatch({ type: "SET_LOADER", payload: true });
    try {
      ApiService.request(
        {},
        `providers-by-year/${state.currentYear.value}`,
        "get"
      )
        .then(function (response) {
          dispatch({ type: "SET_LISTPRESTATAIRES", payload: response.data });
          //console.log(response.data);
          dispatch({ type: "SET_LOADER", payload: false });
        })
        .catch(function (error) {
          dispatch({ type: "SET_LOADER", payload: false });
          if (error.response.data.message === "Unauthenticated.") {
            localStorage.clear();
            dispatch({ type: "SET_LOGOUT", payload: false });
          }
        });
    } catch (error) {
      dispatch({ type: "SET_LOADER", payload: false });
      console.log(error.message);
    }
  };

  React.useEffect(() => {
    if (detailsPlan) {
      getAllOperationsType();
      getComTools();
      getAllPrestataires();
      getPlansPlv();
      getAllOperationsByPlan();
    } else {
      dispatch({ type: "SET_DETAILSPLANOPERATIONS", payload: [] });
    }
  }, [filterMonth, detailsPlan]);

  return (
    <>
      <div className="row mt-5">
        <div className="col-md-8">
          <h2 className="h1">
            {detailsPlan.name}
            {(parseInt(localStorage.getItem("user_role")) !== 5 &&
              parseInt(localStorage.getItem("user_role")) !== 6) && (
              <Dropdown className="d-inline-block">
                <Dropdown.Toggle>
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item onClick={handleShowAdd}>
                    <AddCircleOutlineOutlinedIcon /> Ajouter
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            )}
          </h2>
        </div>
        <div className="col-md-2">
          <Button
            onClick={() => setShowApplyPlan(true)}
            className="button green-button no-border"
          >
            Appliquer le plan
          </Button>
        </div>
        <div className="col-md-2">
          <Select
            placeholder="Mois.."
            required
            isMulti={false}
            name="month"
            value={filterMonth}
            onChange={(e) => filterByMonth(e)}
            options={state.allMonth}
            className="bg-blue-light black border-white"
          />
        </div>
      </div>
      <ToastContainer />
      {showAddOperation && (
        <OperationModalRegisterOrUpdate
          controlFormId={"addPlanOperation"}
          showOperation={showAddOperation}
          addOrUpdateOperation={addOperation}
          selectOperation={selectOperation}
          setSelectOperation={setSelectOperation}
          monthOne={monthOne}
          setMonthOne={setMonthOne}
          monthTwo={monthTwo}
          setMonthTwo={setMonthTwo}
          monthThree={monthThree}
          setMonthThree={setMonthThree}
          selectOffre={selectOffre}
          setSelectOffre={setSelectOffre}
          descriptionOtherOffer={descriptionOtherOffer}
          setDescriptionOtherOffer={setDescriptionOtherOffer}
          isCheckedComTool={isCheckedComTool}
          handleOnChangeComTool={handleOnChangeComTool}
          isCheckedMerchandising={isCheckedMerchandising}
          handleOnChangeMerchandising={handleOnChangeMerchandising}
          operationMerchandisingData={operationMerchandisingData}
          operationCommunicationToolsData={operationCommunicationToolsData}
          handleQuantityMerchandising={handleQuantityMerchandising}
          commentOperation={commentOperation}
          setCommentOperation={setCommentOperation}
          handleClose={handleClose}
          errorMessageMonths={errorMessageMonths}
          listPlvs={state.listDetailsPlanPlvs}
          selectPrestataire={selectPrestataire}
          setSelectPrestataire={setSelectPrestataire}
        />
      )}
      {showUpdateOperation && (
        <OperationModalRegisterOrUpdate
          controlFormId={"updatePlanOperation"}
          showOperation={showUpdateOperation}
          addOrUpdateOperation={updateOperation}
          selectOperation={selectOperation}
          setSelectOperation={setSelectOperation}
          monthOne={monthOne}
          setMonthOne={setMonthOne}
          monthTwo={monthTwo}
          setMonthTwo={setMonthTwo}
          monthThree={monthThree}
          setMonthThree={setMonthThree}
          selectOffre={selectOffre}
          setSelectOffre={setSelectOffre}
          descriptionOtherOffer={descriptionOtherOffer}
          setDescriptionOtherOffer={setDescriptionOtherOffer}
          isCheckedComTool={isCheckedComTool}
          handleOnChangeComTool={handleOnChangeComTool}
          isCheckedMerchandising={isCheckedMerchandising}
          handleOnChangeMerchandising={handleOnChangeMerchandising}
          operationMerchandisingData={operationMerchandisingData}
          operationCommunicationToolsData={operationCommunicationToolsData}
          handleQuantityMerchandising={handleQuantityMerchandising}
          commentOperation={commentOperation}
          setCommentOperation={setCommentOperation}
          handleClose={handleClose}
          errorMessageMonths={errorMessageMonths}
          listPlvs={state.listDetailsPlanPlvs}
          selectPrestataire={selectPrestataire}
          setSelectPrestataire={setSelectPrestataire}
        />
      )}
      {showApplyPlan && (
        <Modal
          show={showApplyPlan}
          size="lg"
          onHide={() => handleClose()}
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              Applique le plan
              <span className="grey-blue">{" " + detailsPlan.name}</span> à une
              liste
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <TableDynamic
              controlTableId={"planslistDetailsPlain"}
              columnsName={columnsName}
              columns={columns}
              data={state.plansTradeCustomersList.data}
              dataPagination={state.plansTradeCustomersList}
              setNoResultMessage={setNoResultMessage}
              noResultMessage={noResultMessage}
              search={searchCustomersList}
              getDataPagination={getPlanCustomersList}
              setCheckedCustomersListIds={setCheckedCustomersListIds}
              checkedCustomersListIds={checkedCustomersListIds}
            ></TableDynamic>
          </Modal.Body>
          <Modal.Footer className="is-bottom-right">
            <Button
              variant="secondary"
              onClick={() => {
                handleClose();
              }}
            >
              Annuler
            </Button>
            <Button
              variant="success"
              disabled={
                checkedCustomersListIds && checkedCustomersListIds.length > 0
                  ? false
                  : true
              }
              onClick={(e) => {
                e.preventDefault();
                applyPlanTrade();
              }}
            >
              Valider
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {state.detailsPlanOperations &&
      !state.loader &&
      state.detailsPlanOperations.length > 0 ? (
        state.detailsPlanOperations.map((operation, i) => (
          <AccordionOperations
            key={i}
            operation={operation}
            keyAccordion={i}
            handleShowUpdate={handleShowUpdate}
            getNameMonth={getNameMonth}
            deleteOperation={deleteOperation}
          />
        ))
      ) : state.loader ? (
        <div className="text-center pt-5">
          <Spinner animation="border" role="status"></Spinner>
        </div>
      ) : (
        <Card className="text-center">
          <Card.Body>
            <Alert variant="info" className="m-0">
              La liste est vide.
            </Alert>
          </Card.Body>
        </Card>
      )}
    </>
  );
};

export default DetailsPlan;
